import { ActionDefinition } from "components/actions/actions";
import { ItemFinderModalDefinition, ItemFinderModalParams } from "components/input/searcherWithCode/baseItemFinderElement";
import { ParameterMap } from "components/input/searcherWithCode/baseSearcherDefinition";

export interface ItemFinderActionDefinition extends ActionDefinition {
    finder: ItemFinderModalDefinition;
    outputParameterMappings?: ParameterMap[];
    queryParameters?: ItemFinderModalParams;
}

export function isItemFinderActionDefinition(arg: any): arg is ItemFinderActionDefinition {
    return arg != null && arg.finder !== undefined && arg.actionType === "finder";
}
